import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  vmDataService,
  vmSharedModelService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './send-notifications-dialog.controller';
import template from './send-notifications-dialog.html';
//import bulkChangeAssetTypesConfirmDialog from '../dialog.bulkChangeAssetTypesConfirmDialog';


class dialogService {
  getOptions($event, { alertList }) {
    return {
      controller,
      controllerAs: 'sendNotificationsDialogVM',
      locals: {
       alertList
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.notifications.sendNotificationsDialog', [
  ngCookies,
  vmDataService,
  vmSharedModelService,
  constants,
  ssDialogService,
  alerts,
  loaderService,
])
  .service('sendNotificationsDialog', dialogService)
  .name;
